module.exports = __webpack_public_path__ + "img/danger_icon_dark.947a7706.svg";